import type { EntityKind } from './types'

import { queryOptions } from '@tanstack/react-query'

import { getDirectory, getPlayerProfile, getTeamProfile } from './api'

export const footballEntityQueryKeys = {
  all: ['football-public-entities'] as const,
  directory: (input: { q: string, type: EntityKind, page: number }) => [
    ...footballEntityQueryKeys.all,
    'directory',
    input.q.trim(),
    input.type,
    input.page,
  ] as const,
  team: (teamId: string, playerPage: number) => [
    ...footballEntityQueryKeys.all,
    'team',
    teamId,
    playerPage,
  ] as const,
  player: (playerId: string, appearancePage: number, at?: string) => [
    ...footballEntityQueryKeys.all,
    'player',
    playerId,
    appearancePage,
    at ?? 'current',
  ] as const,
}

export function directoryQueryOptions(input: { q: string, type: EntityKind, page: number }) {
  return queryOptions({
    queryKey: footballEntityQueryKeys.directory(input),
    queryFn: ({ signal }) => getDirectory({ ...input, signal }),
    staleTime: 60_000,
    retry: 1,
  })
}

export function teamProfileQueryOptions(teamId: string, playerPage = 1) {
  return queryOptions({
    queryKey: footballEntityQueryKeys.team(teamId, playerPage),
    queryFn: ({ signal }) => getTeamProfile({ teamId, playerPage, signal }),
    staleTime: 60_000,
    retry: 1,
  })
}

export function playerProfileQueryOptions(playerId: string, appearancePage = 1, at?: string) {
  return queryOptions({
    queryKey: footballEntityQueryKeys.player(playerId, appearancePage, at),
    queryFn: ({ signal }) => getPlayerProfile({ playerId, appearancePage, at, signal }),
    staleTime: 60_000,
    retry: 1,
  })
}
